<template>
    <div class="reportManage">
      <router-view></router-view>
    </div>
</template>


<script>
export default {
  name: "reportManage",
  data() {
    return {};
  }
};
</script>

<style lang="stylus" scoped>
    
</style>
